export const lang = {
  login: "登录注册",
  snedCode: "发送验证码",
  enterPhone: "请输入您的手机号码",
  enterPwd: "请输入您的登录密码",
  enterPwdLength: "密码长度不能小于6位数",
  wait : "请稍等",
  errorPhone: "请输入正确的手机号",
  signOut: "退出",
  loginOut: "退出成功",
  msgNull: "发送消息不能为空",
  loginPlease: "请先登录",
};
